"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentTitleChangeEvent = exports.ShellRouterNavigationManager = void 0;
var shellRouterNavigationManager_1 = require("./shell/shellRouterNavigationManager");
Object.defineProperty(exports, "ShellRouterNavigationManager", { enumerable: true, get: function () { return shellRouterNavigationManager_1.ShellRouterNavigationManager; } });
Object.defineProperty(exports, "DocumentTitleChangeEvent", { enumerable: true, get: function () { return shellRouterNavigationManager_1.DocumentTitleChangeEvent; } });
//# sourceMappingURL=index.js.map